import EntityPresenter, { bindPresenterMethods } from './entityPresenter'

export default class NoticesPresents extends EntityPresenter {
  static urn = 'notices'
  static key = 'notice'

  static navOptions(key = 'notifications') {
    const routes = {
      notifications: {
        icon: 'notifications',
        pageRoutes: ['notification'],
      },
    }
    return routes[key]
  }
}

bindPresenterMethods(NoticesPresents)
